import React from 'react';

/** Empty-friendly number field: no sticky 0, focus selects so typing replaces. */
export default function NumericInput({ value, onChange, onFocus, ...props }) {
  const display = value === null || value === undefined ? '' : value;

  return (
    <input
      type="number"
      {...props}
      value={display}
      onChange={onChange}
      onFocus={(e) => {
        e.target.select();
        onFocus?.(e);
      }}
    />
  );
}
